import styled from 'styled-components';
import { device } from '../../theme';

export const SectionWrap = styled.section`
  padding-top: 100px;
  padding-bottom: 100px;
  background-position: bottom left;
  background-size: auto;
  @media ${device.medium} {
    padding-top: '80px';
    padding-bottom: '80px';
  }
  @media ${device.small} {
    padding-top: '60px';
    padding-bottom: '60px';
  }
`;

export const Card = styled.div`
  width: 480px;

  @media ${device.medium} {
    max-width: 480px;
  }

  @media ${device.small} {
    width: 100%;
  }
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media ${device.medium} {
    flex-direction: column;
    align-items: center;
  }
`;
